Overrides for an application method when posting or updating from a draft.
